import { Api } from '@deepcloud/api-base'
import type {
  HttpClient,
  HttpClientRequestConfig,
} from '@deepcloud/http-client'
import type { Visibility } from '../../../shared'
import type { AbacusVersions } from '../../@types'

export class MetadataAPI extends Api {
  constructor(httpClient: HttpClient) {
    super(httpClient)
  }

  /**
   * Get Versions
   * -------------------
   * Errors:
   * - none documented
   */
  async getVersions(config?: HttpClientRequestConfig) {
    const path = `/metadata/versions`

    return this.httpClient.get<AbacusVersions[]>(path, config)
  }

  /**
   * Get Applications
   * -------------------
   * Errors:
   * - none documented
   */
  async getApplications(config?: HttpClientRequestConfig) {
    const path = `/metadata/applications`

    return this.httpClient.get<string[]>(path, config)
  }

  /**
   * Get Visibilities
   * -------------------
   * Errors:
   * - none documented
   */
  async getVisibilities(config?: HttpClientRequestConfig) {
    const path = `/metadata/visibilities`

    return this.httpClient.get<Visibility[]>(path, config)
  }
}
